import * as React from 'react'
import * as styles from './BlueBar.module.scss'
import checkUrlType from '../../utils/url-type-checker'
import { StorefrontCollectionMeta as BlueBarProps } from 'DVWebNodeUtils';

const BlueBar = (collectionMeta: BlueBarProps) =>
  <div className={styles.BlueBar}>
    {collectionMeta.slotName &&
      <span className={styles.BlueBarItem}>{collectionMeta.slotName}</span>}
    {collectionMeta.links && collectionMeta.links.map(
      link => <a
        className={styles.BlueBarItem}
        href={checkUrlType(link.url, 'Pagination')}
      >{link.label}</a>
    )}
  </div>

export default BlueBar
